<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    size: { type: String, default: '' },
  },
  methods: {
    onClick() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<template>
  <button
    type="button"
    class="toggle-button p-0"
    :class="{ active: value, small: size === 'small' }"
    role="switch"
    :aria-checked="value.toString()"
    @click="onClick"
  >
    <span aria-hidden="true" :class="{ active: value }" />
  </button>
</template>

<style lang="scss" scoped>
// Interruptor. Quatro correcoes:
//
//   - o estado ligado usava `var(--w-500)`, que hoje aponta para flipdesk-700.
//     Ou seja: o azul do interruptor era mais escuro que o azul da marca em
//     todo o resto da tela. Passou a usar brand-solid, o mesmo do botao.
//   - o thumb era `bg-white dark:bg-slate-900`, entao no tema escuro ele
//     escurecia junto com o fundo e o controle perdia o contraste que o faz
//     legivel. O thumb agora e sempre claro, nos dois temas -- e o TRILHO que
//     muda de cor.
//   - nao havia foco visivel.
//   - `border-radius: var(--border-radius-large)` nao fecha em pill; e as
//     medidas eram 34x19 com thumb de 15px, fora de qualquer escala.
//     Agora 36x20 (thumb 16) e 28x16 (thumb 12) no pequeno.
.toggle-button {
  @apply relative flex shrink-0 items-center cursor-pointer
    w-9 h-5 p-0.5 rounded-full border-0
    bg-line-strong dark:bg-line-strong
    transition-colors duration-200 ease-out;

  &:focus-visible {
    @apply outline-none ring-2 ring-brand/40 ring-offset-2
      ring-offset-surface dark:ring-offset-surface;
  }

  &.active {
    @apply bg-brand-solid dark:bg-brand-solid;
  }

  span {
    @apply block w-4 h-4 rounded-full bg-white dark:bg-white transition-transform duration-200 ease-out;
    transform: translateX(0);

    &.active {
      transform: translateX(1rem);
    }
  }

  &.small {
    @apply w-7 h-4;

    span {
      @apply w-3 h-3;

      &.active {
        transform: translateX(0.75rem);
      }
    }
  }
}
</style>
